<template>
  <div class="search-input-box">
    <button
      class="reset-button-style glyph-container mobile"
      @click="toggleMobile"
    >
      <i class="glyphicon glyphicon-search" />
    </button>
    <div :class="mobileInputCssClasses">
      <label for="mobile-search-input" class="search-input-label">
        Search
      </label>
      <input
        id="mobile-search-input"
        ref="mobileInput"
        type="search"
        class="dropdown-search-input"
        :value="inputValue"
        @keyup="onKeyUp"
        @focus="focus"
        @blur="searchFocused = false"
      />
    </div>

    <div
      :class="'dropdown-search-bar desktop' + (activated ? ' activated' : '')"
    >
      <span class="glyph-container desktop">
        <i class="glyphicon glyphicon-search" />
      </span>
      <label
        v-show="!searchFocused"
        for="search-input"
        class="search-input-label"
      >
        Search
      </label>
      <input
        id="search-input"
        type="search"
        class="dropdown-search-input"
        :value="inputValue"
        @keyup="onKeyUp"
        @focus="focus"
        @blur="searchFocused = false"
      />
    </div>
    <a
      id="search-icon-mobile"
      class="header-search-link"
      style="display: none;"
    >
      <span class="glyphicon glyphicon-search" />
    </a>
  </div>
</template>

<script>
  export default {
    model: {
      prop: "queryString",
      event: "change",
    },
    props: {
      minQueryLength: { type: Number, required: true, default: 1 },
      activated: { type: Boolean, required: true },
      queryString: { type: String, required: false, default: "" },
    },
    data() {
      return {
        mobileActivated: false,
        inputValue: "",
        searchFocused: false,
      }
    },
    computed: {
      mobileInputCssClasses() {
        const constantClasses = "mobile-search-bar texture-dark"
        return this.mobileActivated
          ? `${constantClasses} visible`
          : constantClasses
      },
    },
    methods: {
      toggleMobile() {
        this.mobileActivated = !this.mobileActivated
        if (this.mobileActivated) {
          this.$nextTick(() => this.$refs.mobileInput.focus())
        } else {
          this.$emit("change", "")
        }
      },
      onKeyUp(event) {
        switch (event.code) {
          case "ArrowDown":
            this.$emit("increment-cursor")
            break
          case "ArrowUp":
            this.$emit("decrement-cursor")
            break
          case "Enter":
            this.$emit("press-enter")
            break
          case "Escape":
            this.$emit("escape")
            break
          default:
            this.$emit("change", event.target.value)
        }
      },
      focus() {
        this.searchFocused = true
        this.$emit("search-focus")
      },
    },
  }
</script>
